export const GET_CITY_BIKES = 'cityBikes/GET_CITY_BIKES';
export const CLEAR_CITY_BIKES = 'cityBikes/CLEAR_CITY_BIKES';



// WEBPACK FOOTER //
// ./src/constants/cityBikes.js